(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-grid__item[data-variant-id]').forEach(function (card) {
      const variantId = card.getAttribute('data-variant-id');
      if (!variantId) return;

      fetch('/variants/' + variantId + '.js')
        .then(res => res.json())
        .then(variant => {

          /// Update all links in the card to point to this specific variant
const allLinks = card.querySelectorAll('a[href]');
if (allLinks.length > 0) {
  // Build variant URL from existing link + variant ID
  const existingLink = allLinks[0];
  const productUrl = existingLink.href.split('?')[0];
  const variantUrl = productUrl + '?variant=' + variantId;
  allLinks.forEach(link => {
    link.href = variantUrl;
  });
}

          // Update product image to show this variant's image
          if (variant.featured_image) {
            const img = card.querySelector('img');
            if (img) {
              const cleanSrc = variant.featured_image.src.split('?')[0];
              const newSrc = cleanSrc + '?width=800';
              img.onload = () => img.classList.add('variant-image--loaded');
              img.src = newSrc;
              img.srcset = newSrc;
              if (img.hasAttribute('data-src')) {
                img.setAttribute('data-src', newSrc);
              }
            }
          }

          // Update any hidden variant ID input (for add to cart)
          const idInput = card.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;

          // Update any add-to-cart component variant attribute
          const atcComponent = card.querySelector('add-to-cart-component, [data-variant-id]');
          if (atcComponent && atcComponent !== card) {
            atcComponent.setAttribute('data-variant-id', variantId);
          }

        })
        .catch(err => console.warn('Ritual variant swap failed for variant ' + variantId + ':', err));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
